import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import '../fonts/TIMES.TTF-16-Regular.woff';

const Main = function () {
  const imgSrc = null;

  const style = {
    background: `url(${imgSrc}) no-repeat scroll center center / 5em auto`
  };

  const portrait = 'https://images.getpie.app/users/e541d6b0-29c8-11ef-8aa7-f509ad0c08d1/profile-146683b9-46a7-4131-863f-31dda8abf5af.jpg';

  return (
    <div className="flex flex-column flex-row-l">
      <div className="w-100 w-50-l bg-black white f5 times-bold">
        <div className="vh-100 dt w-100 tc landing" style={style}>
          <div className="dtc v-mid">
            <div className="tc pa1">
              <img src={portrait} alt="Portrait" className="br-100 ba h4 w4 portrait"/>
            </div>
            <div className="dib f4">
              hunter husar
            </div>
          </div>
        </div>
      </div>
      <div className="w-100 w-50-l">
        <div className="vh-100">
          <div className="pa1">
            computer person, synthesist, friend to all, husband.
          </div>
          <div className="pa1">
            lead engineer @ pie
          </div>
        </div>
      </div>
    </div>
  );
}

ReactDOM.render(
  <Main/>,
  document.getElementById('root')
);



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/